<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>修改学生</h1>
        <span class="pull-right icon-right orange" @click.prevent="editStudent()">保存</span>
      </div>
      <div class="liner"></div>
    </div>

    <div class="main-page" style="padding-bottom:60px;">
        <!--王备写的-->
        <p class="margin-15">红色“*”为必填项，请认真填写。</p>
        <ul class="list-group-item tinny">
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix upload-head upload-pic">
              <form enctype="multipart/form-data" method="post" name="fileinfo">
                <span class="pull-left">上传头像</span>
                <span class="pull-right"><img :src="imageAddress ? baseAcessPath + imageAddress : img_default" width="60" height="60"></span>
                <span class="upload-wrap" @click="capturePhoto();" v-if="isAndroid"></span>
                <span class="upload-wrap" v-else><input type="file" name="pic" id="pic" accept="image/*" size="1" @change="updateImage()"/></span>
              </form>
            </div>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">学生姓名：</span><i class="red must">*</i>
              <span class="pull-right gray"><input class="text-right font-14" type="text" placeholder="请输入学生姓名" v-model="studentName"></span>
            </div>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">性别：</span><i class="red must">*</i>
              <span class="pull-right clearfix checkbox-group">
                <cite class="pull-right img-checkbox" v-bind:class="{'checked': sex == '女'}" @click="sex = '女'">女</cite>
                <cite class="pull-right img-checkbox" v-bind:class="{'checked': sex == '男'}" @click="sex = '男'">男</cite>
              </span>
            </div>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix group-txt img-more" @click="openPicker('picker')">
              <span class="pull-left">出生年月：</span>
              <span class="pull-right margin-x-15 gray font-12">{{birthday ? birthday : '请选择'}}</span>
            </div>
          </li>
        </ul>
        <ul class="list-group-item tinny">
          <li class="list-group">
            <div class="liner"></div>
            <a href="javascript:;" class="clearfix group-txt">
              <span class="pull-left">所在学校：</span>
              <span class="pull-right gray"><input class="text-right font-14" type="text" placeholder="请输入" v-model="szxx"></span>
            </a>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <a class="clearfix group-txt img-more" @click.prevent="isHideSchoolGrade = false">
              <span class="pull-left">年级：</span>
              <span class="pull-right margin-x-15 gray font-12">{{grade ? grade : '请选择'}}</span>
            </a>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <a class="clearfix group-txt img-more" @click.prevent="isHideSchoolClass = false">
              <span class="pull-left">班级：</span>
              <span class="pull-right margin-x-15 gray font-12">{{className ? className + '班' : '请选择'}}</span>
            </a>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <a class="clearfix group-txt img-more" @click.prevent="getCurcheServiceList()">
              <span class="pull-left">托管服务：</span>
              <span class="pull-right margin-x-15 gray font-12">{{curcheServiceName}}</span>
            </a>
          </li>
        </ul>

        <span class="margin-x-15 gray">家长信息<small class="orange" v-if="parentlist.length > 0">（已激活的家长手机号只能家长自己修改）</small></span>
        <ul class="list-group-item tinny">
          <li class="list-group" v-for="item in parentlist">
            <div class="liner"></div>
            <a class="clearfix group-txt">
              <span class="pull-left">{{item.parentRole}}</span>
              <span class="pull-left margin-x-15 gray" v-if="item.djlxr == '1'">第一联系人</span>
              <span class="margin-x-15 pull-right">{{item.phoneNum}}</span>
            </a>
          </li>
          <template v-if="parentlist.length == 0">
            <li class="list-group">
              <div class="liner"></div>
              <a class="clearfix group-txt img-more" @click.prevent="isHideParentRole = false">
                <span class="pull-left">监护角色：</span><i class="red must">*</i>
                <span class="pull-right gray margin-x-15 font-12">{{parentRole ? parentRole : '请选择'}}</span>
              </a>
            </li>
            <li class="list-group">
              <div class="liner"></div>
              <div class="clearfix group-txt">
                <span class="pull-left">手机号码：</span><i class="red must">*</i>
                <span class="pull-right gray"><input class="text-right font-14" type="number" placeholder="请输入手机号码" v-model="parentPhone"></span>
              </div>
            </li>
          </template>
        </ul>

        <ul class="list-group-item tinny" v-if="info.sfzt == '在托'">
          <li class="list-group" >
            <div class="liner"></div>
            <a class="clearfix  group-txt  text-center font-16" @click.prevent="isHideSfzt = false">离托</a>
            <!-- <a class="clearfix  group-txt  text-center font-16" @click.prevent="isHideSfzt = false">{{info.sfzt == '在托' ? '离托' : '返托'}}</a> -->
          </li>
        </ul>

        <ul class="list-group-item tinny text-center" v-else>
            <li class="list-group" >
              <div class="liner"></div>
              <a class="group-txt" @click.prevent="isHideSfzt = false">返托</a>
            </li>
            <li class="list-group" >
              <div class="liner"></div>
              <span class="group-txt"  @click="isHideDeleteStudent = false" v-if="(cookie_login_data.jobId === 1 || cookie_login_data.jobId === 2) && info.sfzt == '离托'">删除</span>
            </li>
        </ul>
      </div>

    <div class="maskdiv" v-show="!isHideSetCurcheServiceDialog" @click="isHideSetCurcheServiceDialog = true">
      <div class="popover" @click.stop>
        <div class="pop-wrap text-center">
          <p v-if="cookie_login_data.jobId == 1 || cookie_login_data.jobId == 2">该园点还未设置托管服务，请到“园点管理”处设置。</p>
          <p v-else>该园点还未设置托管服务，请联系管理员到“园点管理”处设置。</p>
          <div class="liner margin-15"></div>
          <div class="clearfix" v-if="cookie_login_data.jobId == 1 || cookie_login_data.jobId == 2">
            <div class="col-xs-6 blue"><router-link class="blue  block" style="border-right:1px solid #ddd;" :to="{'path': '/curche/edit'}">去设置</router-link></div>
            <div class="col-xs-6 blue"><a class="blue" @click.prevent="isHideSetCurcheServiceDialog = true">以后再说</a></div>
          </div>
          <div class="clearfix" v-else>
            <div class="col-xs-12 blue"><a class="blue" @click.prevent="isHideSetCurcheServiceDialog = true">以后再说</a></div>
          </div>
        </div>
      </div>
    </div>

      <!-- 关联服务 -->
    <div class="maskdiv" v-show="!isHideCurcheService" @click="isHideCurcheService = true">
      <div class="slider" @click.stop>
        <strong class="tit">关联服务</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny" v-if="curcheServiceList.length > 0">
          <ul v-for="item in curcheServiceList">
            <li @click="csId = item.csId, isHideCurcheService = true, curcheServiceName = item.serviceName + ' ' + item.currentServiceFee + '元/月'">
              <div class="clearfix group-link"><span class="pull-left">{{item.serviceName}} {{item.currentServiceFee}}元/月</span>
                <template v-if="item.csId == csId">
                  <i class="pull-right img-checkbox checked"></i>
                </template>
                <template v-else>
                  <i class="pull-right img-checkbox"></i>
                </template>
                </div>
                <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>

      <!-- 关联班级 -->
    <div class="maskdiv" v-show="!isHideCurcheClass" @click="isHideCurcheClass = true">
      <div class="slider" @click.stop>
        <strong class="tit">编入班级</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in curcheClassList">
            <li @click="classId = item.classId, curcheClassName = item.className, isHideCurcheClass = true">
              <div class="clearfix group-link"><span class="pull-left">{{item.className}}</span>
              <template v-if="item.classId == classId">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>

      <!-- 关联学校年级 -->
    <div class="maskdiv" v-show="!isHideSchoolGrade" @click="isHideSchoolGrade = true">
      <div class="slider" @click.stop>
        <strong class="tit">选择年级</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in gradeList">
            <li @click="grade = item, isHideSchoolGrade = true">
              <div class="clearfix group-link"><span class="pull-left">{{item}}</span>
              <template v-if="item == grade">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>

      <!-- 关联学校班级 -->
    <div class="maskdiv" v-show="!isHideSchoolClass" @click="isHideSchoolClass = true">
      <div class="slider" @click.stop>
        <strong class="tit">选择班级</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in 20">
            <li @click="className = (item + 1), isHideSchoolClass = true">
              <div class="clearfix group-link"><span class="pull-left">{{item + 1}}班</span>
              <template v-if="item == className">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 修改在托返托 -->
    <div class="maskdiv" v-show="!isHideSfzt" @click="isHideSfzt = true">
      <div class="popover" @click.stop>
        <div class="pop-wrap pop-parents">
          <div class="clearfix margin-x-15">
            <div class="pull-left"><img class="rounded-60" :src="info.imageAddress ? info.baseAcessPath + info.imageAddress : img_default" width="60" height="60"></div>
            <div class="pull-left padding-10 margin-x-15">
              <p class="font-16 clearfix"><span class="pull-left">{{info.studentName}}</span>
                <span class="pull-left img-sex" v-bind:class="{'boy': info.sex == '男','girl': info.sex == '女'}"></span>
              </p>
              <p class="gray">{{info.grade}}{{info.className}}{{info.typeName ? '（' + info.typeName +'）' : ''}}</p>
            </div>
          </div>
          <p class="text-center padding-15">确定“{{info.sfzt == '在托' ? '离托' : '返托'}}”吗？</p>
          <div class="liner margin-x-15"></div>
          <div class="clearfix text-center">

            <div class="col-xs-6" v-if="info.sfzt == '在托'"><a @click.prevent="leaveStudent()" class="blue block padding-15"><span class="block" style="border-right:1px solid #e3e3e3">确定</span></a></div>
            <div class="col-xs-6" v-if="info.sfzt == '离托'"><a @click.prevent="returnStudent()" class="blue block padding-15"><span class="block" style="border-right:1px solid #e3e3e3">确定</span></a></div>

            <div class="col-xs-6"><a @click.prevent="isHideSfzt = true" class="blue block padding-15"><span class="block">取消</span></a></div>
          </div>
        </div>
      </div>
    </div>

      <!-- 关联家长 -->
      <!-- 关联监护角色 -->
    <div class="maskdiv" v-show="!isHideParentRole" @click="isHideParentRole = true">
      <div class="slider" @click.stop>
        <strong class="tit">监护角色</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in parentRoleList">
            <li @click="parentRole = item, isHideParentRole = true">
              <div class="clearfix group-link"><span class="pull-left">{{item}}</span>
              <template v-if="item == parentRole">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="maskdiv" v-show="!isHideDeleteStudent" @click="isHideDeleteStudent = true">
      <div class="popover" @click.stop>
        <div class="pop-wrap text-center">
          <p>确定要删除该学生吗？</p>
          <div class="liner margin-15"></div>
          <div class="clearfix">
            <div class="col-xs-6 blue"><a hre="javascript:;" class="blue  block" style="border-right:1px solid #ddd;" @click.prevent="deleteStudentItem()">删除</a></div>
            <div class="col-xs-6 blue"><a hre="javascript:;" class="blue" @click="isHideDeleteStudent = true">不删除</a></div>
          </div>
        </div>
      </div>
    </div>

    <mt-datetime-picker type="date" year-format="{value} 年" ref="picker"
        month-format="{value} 月" date-format="{value} 日" @confirm="handleChange" :start-date="pickerStartDate" :end-date="pickerEndDate">
    </mt-datetime-picker>
  </div>
</template>

<script>
var startDate = new Date()
startDate.setFullYear(startDate.getFullYear() - 20)
import { service, uploadUrl } from '../../service'
import { Toast, Indicator } from 'mint-ui'
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_student_para: service.setPara('getStudentMsg'),
      edit_student_para: service.setPara('editStudent'),
      get_curche_class_para: service.setPara('getClassList'),
      get_curche_service_para: service.setPara('getCurcheServicelist'),
      update_parent_para: service.setPara('editParent'),
      add_parent_para: service.setPara('addParent'),
      del_parent_para: service.setPara('deleteParent'),
      leave_student_para: service.setPara('leaveStudent'), // 离托
      return_student_para: service.setPara('returnStudent'), // 反托
      delete_student_para: service.setPara('deleteStudent'), // 删除学生
      // get_curche_service_para: {method: 'getCurcheServicelist', client_type: window.client_type, version: window.version},
      isHideSetCurcheServiceDialog: true, // 是否隐藏设置园点服务弹出框
      isHideCurcheService: true, // 是否隐藏园点服务选择
      isHideCurcheClass: true, // 是否隐藏园点班级选择
      isHideSchoolGrade: true, // 是否隐藏学校年级选择
      isHideSchoolClass: true, // 是否隐藏学校班级
      isHideParentRole: true, // 是否隐藏家长角色
      isHideSfzt: true, // 在托 离托
      isHideDeleteStudent: true, // 删除学生
      curcheId: 0,
      curcheName: '',
      imageAddress: '',
      studentName: '',
      sex: '男',
      birthday: '',
      classId: '', // 编入园点班级
      csId: '', // 园点服务id
      className: '', // 学校班级名称
      grade: '', // 学校年级
      szxx: '', // 园点地址
      // 关联家长
      parentRoleList: ['爸爸', '妈妈', '爷爷', '奶奶', '哥哥', '姐姐', '外公', '外婆', '叔叔', '阿姨', '家教', '其他'],

      // 家长信息 开始
      parentPhone: '',
      parentRole: '',
      parentlist: [],
      curcheServiceList: [],
      curcheClassList: [],
      curcheServiceName: '请选择托管服务',
      curcheClassName: '请选择班级',
      gradeList: ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '初中一年级', '初中二年级', '初中三年级'],
      info: {},
      parentId: 0,
      baseAcessPath: '',
      studentId: 0,
      isAndroid: true,
      teacherId: 0,
      // pickerVisible: false,
      pickerStartDate: startDate,
      pickerEndDate: new Date()
    }
  },
  mounted: function () {
    this.studentId = this.$route.params.studentId
    let b = window.browser()
    this.isAndroid = b.android
    this.init()
  },
  methods: {
    ...mapMutations([
      'clearStudents',
      'clearStudentParents',
      'deleteStudent'
    ]),
    openPicker (picker) {
      this.$refs[picker].open()
    },
    handleChange: function (value) {
      this.birthday = value.format('yyyy-MM-dd')
    },
    init: function () {
      this.curcheId = this.login_data[this.cookie_login_data.index].curcheId
      this.curcheName = this.login_data[this.cookie_login_data.index].curcheName
      this.teacherId = this.cookie_login_data.teacherId

      this.get_student_para.studentId = this.studentId

      var that = this
      let obj = {context: this, para: this.get_student_para, successFun: (response) => {
        that.info = response.data
        that.curcheId = that.info.curcheId
        that.curcheName = that.info.curcheName
        that.imageAddress = that.info.image_address
        that.studentName = that.info.studentName
        that.sex = that.info.sex
        that.parentRole = that.info.parentRole
        that.parentPhone = that.info.parentPhone

        that.birthday = that.info.studentBirthday
        that.baseAcessPath = that.info.baseAcessPath

        that.classId = that.info.class_id
        that.csId = that.info.typeId
        if (that.info.class_name) {
          that.className = that.info.class_name.substr(0, that.info.class_name.indexOf('班'))
        }
        that.grade = that.info.grade
        that.szxx = that.info.szxx

        // that.curcheServiceName = that.info.typeName ? (that.info.typeName + ' ' + that.info.field3 + '元/月') : '请选择'
        that.curcheServiceName = that.info.typeName ? that.info.typeName : '请选择'
        that.curcheClassName = that.info.relation_className
        that.parentlist = that.info.parentList
      }}
      service.request(obj)
    },
    getCurcheServiceList: function () {
      if (this.curcheServiceList.length > 0) {
        this.isHideCurcheService = false
        return
      }
      this.get_curche_service_para.curcheId = this.curcheId

      let that = this
      let obj = {context: this, para: this.get_curche_service_para, successFun: (response) => {
        that.curcheServiceList = response.data
        if (that.curcheServiceList.length > 0) {
          // that.csId = that.curcheServiceList[0].csId
          that.isHideCurcheService = false
        } else {
          that.isHideSetCurcheServiceDialog = false
        }
      }}
      service.request(obj)
    },
    getCurcheClassList: function () {
      if (this.curcheClassList.length > 0) {
        this.isHideCurcheClass = false
        return
      }
      this.get_curche_class_para.curcheId = this.curcheId

      let that = this
      let obj = {context: this, para: this.get_curche_class_para, successFun: (response) => {
        that.curcheClassList = response.data
        if (that.curcheClassList.length > 0) {
          // this.csId = this.curcheClassList[0].csId
          that.isHideCurcheClass = false
        }
      }}
      service.request(obj)
    },
    editStudent: function () {
      if ($.trim(this.studentName) === '') {
        Toast('请输入姓名')
        return
      }

      if (this.info.parentList == 0) {
        if ($.trim(this.parentRole) === '') {
          Toast('请选择家长角色')
          return
        }
        var reg = /^1\d{10}$/
        if (!reg.exec($.trim(this.parentPhone))) {
          Toast('请输入正确的手机号')
          return
        }
      }

      this.edit_student_para.studentId = this.studentId
      this.edit_student_para.imageAddress = this.imageAddress
      this.edit_student_para.studentName = $.trim(this.studentName)
      this.edit_student_para.sex = this.sex
      this.edit_student_para.studentBirthday = this.birthday
      this.edit_student_para.classId = this.classId
      if (this.curcheServiceName != '' && this.curcheServiceName != '请选择') {
        this.edit_student_para.typeName = this.curcheServiceName
        this.edit_student_para.typeId = this.csId
      } else {
        this.edit_student_para.typeName = ''
        this.edit_student_para.typeId = ''
      }
      this.edit_student_para.class_name = this.className ? this.className + '班' : ''
      this.edit_student_para.grade = this.grade
      this.edit_student_para.szxx = this.szxx
      this.edit_student_para.parentRole = this.parentRole
      this.edit_student_para.parentPhone = this.parentPhone

      let obj = {context: this, para: this.edit_student_para, successFun: (response) => {
        this.$store.dispatch('clearStudents')
        this.$store.dispatch('clearStudentParents')
        window.history.go(-1)
      }}
      service.request(obj)
    },
    leaveStudent: function () {
      this.leave_student_para.studentId = this.studentId

      let obj = {context: this, para: this.leave_student_para, successFun: (response) => {
        Toast('离托成功')
        this.$store.dispatch('clearStudents')
        this.$store.dispatch('clearStudentParents')
        this.info.sfzt = '离托'
        this.isHideSfzt = true
      }}
      service.request(obj)
    },
    returnStudent: function () {
      this.return_student_para.studentId = this.studentId

      let obj = {context: this, para: this.return_student_para, successFun: (response) => {
        Toast('返托成功')
        this.$store.dispatch('clearStudents')
        this.$store.dispatch('clearStudentParents')
        this.info.sfzt = '在托'
        this.isHideSfzt = true
      }}
      service.request(obj)
    },
    // 删除学生
    deleteStudentItem: function () {
      this.delete_student_para.studentId = this.studentId
      this.delete_student_para.teacherId = this.teacherId
      this.delete_student_para.curcheId = this.curcheId
      this.delete_student_para.curcheName = this.curcheName

      let obj = {context: this, para: this.delete_student_para, successFun: (response) => {
        Toast('删除成功')
        this.$store.dispatch('deleteStudent', this.studentId)
        this.$store.dispatch('clearStudentParents')
        window.history.go(-2)
      }}
      service.request(obj)
    },
    updateImage: function () {
      if (document.getElementById('pic').files.length === 0) {
        return
      }

      var that = this

      lrz(document.getElementById('pic').files[0], {width: 100})
      .then(function (rst) {
        var data = new window.FormData()
        data.append('pic', rst.file, rst.origin.name)
        let url = uploadUrl + that.cookie_login_data.phoneNum + '&needThumb=1'

        let obj = {context: that, para: data, url: url, successFun: (response) => {
          that.imageAddress = response.data.thumbFilePath
        }}
        service.request(obj)
      })
    },
    capturePhoto: function () {
      Indicator.open()
      navigator.camera.getPicture(this.onPhotoDataSuccess, this.onFail, { quality: 80, destinationType: navigator.camera.DestinationType.DATA_URL, sourceType: navigator.camera.PictureSourceType.PHOTOLIBRARY, targetWidth: 200, targetHeight: 200 })
    },
    onPhotoDataSuccess: function (imageData) {
      let imgData = 'data:image/jpeg;base64,' + imageData
      let f = {}
      f.file = this.dataURLtoBlob(imgData)
      f.name = '0.png'

      var data = new window.FormData()
      data.append('pic', f.file, f.name)
      let url = uploadUrl + this.cookie_login_data.phoneNum + '&needThumb=1'
      let obj = {context: this, para: data, url: url, successFun: (response) => {
        this.baseAcessPath = response.data.baseAcessPath
        this.imageAddress = response.data.thumbFilePath
        Indicator.close()
      }}
      service.request(obj)
    },
    onFail: function (message) {
      Indicator.close()
      // alert('Failed because: ' + message)
    },
    dataURLtoBlob: function (dataurl) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = window.atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new window.Blob([u8arr], {type: mime})
    }
  }
}
</script>



// WEBPACK FOOTER //
// StudentEdit.vue?1bcbb3c2